export const tokenAddress = "0xaD65106b738a9d1b0de6568251199e123084A131";
export const BoonAddress = "0x4D2cFF9D7eBBC8B48178074C274a31B979F59D9B";

